module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-5-53889703937b0cd9177ace0cff612e1d.jpg";